module.exports = __webpack_public_path__ + "static/media/william.4e6ddb28.png";